import type { TranslatableText } from './../../../types/TranslatableText.type'

export class GalleryItem {
  _id: string = undefined as any
  titles: TranslatableText = {
    en: '',
    fr: '',
  }
  thumbnailImage = ''
  image = ''
  weight = -1
  visible = false
}
